import { computed } from 'vue'
export function useModelWrapper(props, emit, name = 'data') { 
  console.log('wrapper:' + name)
  return computed({ 
    get: () => props[name], 
    set: (value) => emit(`update:${name}`, value) 
  })
}